import React, {useEffect, useState}					from 'react';
import {useNavigate}								from 'react-router-dom';
import moment										from 'moment';
import jschardet									from 'jschardet';

import Button										from '../ressources/components/Button';
import Input										from '../ressources/components/Input';
import Tabs											from '../ressources/components/Tabs';
import Select										from '../ressources/components/Select';
import Icon											from '../ressources/components/Icon';
import ButtonStickyContainer						from '../ressources/components/Button/ButtonStickyContainer';
import DocumentItem									from '../ressources/components/Document';
import Section										from '../ressources/components/Section';
import Badge										from '../ressources/components/Badge';
import ModalAssign									from '../ressources/components/ModalAssign';
import Modal										from '../ressources/components/Modal';
import MultiInputContainer							from '../ressources/components/Input/MultiInputContainer';
import {DeviceStatus}								from '../ressources/components/Device';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {postDevicesApi}								from '../redux/devices/devices';
import {PutDeviceData}								from '../redux/devices/interface';
import {DeviceStatus as int_DeviceStatus}			from '../ressources/language/type';
import {User}										from '../redux/user/interface';
import {SelectData, SelectValues}					from '../ressources/components/Select/interface';
import {TabsValues}									from '../ressources/components/Tabs/interface';
import {InputValues}								from '../ressources/components/Input/interface';

import {ft_genNotification, ft_pushNotification} 	from '../ressources/functions/notification';
import {ft_selectDataGetMemory, ft_selectDataGetNetwork,
	ft_selectDataGetStockage, ft_selectDataString,
	ft_selectDataUser}								from '../ressources/functions/selectData';
import {ft_fixText}									from '../ressources/functions/text';
import {ft_replaceSpecialChar}						from '../ressources/functions/search';
import {ft_getDeviceImageByString}					from '../ressources/functions/deviceFunction';
import ft_cssVar									from '../ressources/functions/getCssVar';
import {ft_csvToArray}								from '../ressources/functions/file';
import {ft_findUser}								from '../ressources/functions/userFunction';

import img_computer									from '../ressources/images/icon/devices/computer.svg';
import img_roundCheck								from '../ressources/images/icon/check.svg';
import img_cross									from '../ressources/images/icon/close.svg';
import img_dotsVertical								from '../ressources/images/icon/dots-vertical.svg';

import * as API										from '../ressources/API';
import LANGUAGE										from '../ressources/language';
import {regex_dateFormat}							from '../ressources/data/regex';
import {KEYBOARD_LIST, TYPE_LIST}					from '../ressources/data/device';
import {DEVICE_TYPE, LOCATION_TYPE, STATE}			from '../ressources/data/form';

import './Devices.css';

interface DeviceLine {
	name: string,
	purchaseType: string,
	deviceType: string,
	state: string,
	status: keyof int_DeviceStatus,
	internalId: string,
	serial: string,
	supplier: string,
	contractStart: string,
	duration: string,
	monthlyPrice: string,
	contractNumber: string,
	purchasePrice: string,
	purchaseDate: string,
	warrantlyEnd: string,
	billingNumber: string,
	description: string,
	brand: string,
	screenSize: string,
	keyboard: string,
	stockage: string,
	memory: string,
	processor: string,
	graphicCard: string,
	network: string,
	assign?: string
}

interface Error {
	isRequiredErr?: boolean
	text?: string,
	field: keyof DeviceLine
}

interface EditInput {
	title: string,
	name: keyof DeviceLine,
	selectData?: SelectData[],
	type?: string,
	min?: number,
	notFocusValue?: string
}


function DevicesImport() {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);
	const users = useAppSelector(state => state.companyUsers.data);
	let notificationId = useAppSelector(state => state.notifications.lastId);

	const [step, set_step] = useState<number>(1);

	const [lineData, set_lineData] = useState<string[][]>([]);
	const [headerIndex, set_headerIndex] = useState<number[]>([]);
	const [error, set_error] = useState<string | undefined>();

	const [devicesLine, set_devicesLine] = useState<DeviceLine[]>([]);

	const [modal, set_modal] = useState<number | null>(null);
	const [modalEdit, set_modalEdit] = useState<number | null>(null);
	const [modalMenu, set_modalMenu] = useState<TabsValues>('details');

	const [assignUser, set_assignUser] = useState<User>();

	const [load, set_load] = useState(false);

	const navigate = useNavigate();
	const TEXTE = LANGUAGE(lang);
	let foundErrorStep3 = false;

	const IMPORT_DATA_DEVICE_TYPE = TYPE_LIST.map(e => ({value: e, text: TEXTE.global[e].toLowerCase()}));
	const IMPORT_DATA_PURCHASE_TYPE = [
		{value: 'purchase', text: TEXTE.global.purchase.toLowerCase()},
		{value: 'lease', text: TEXTE.global.lease.toLowerCase()}
	];
	const IMPORT_DATA_STATE = [
		{value: 'refurbished', text: TEXTE.global.refurbished.toLowerCase()},
		{value: 'new', text: TEXTE.global.new.toLowerCase()}
	];

	const ACTIONS_LIST: SelectData[] = [
		{
			value:  'edit',
			render: <span className={'text-xs weight-500 gray-700'}>{TEXTE.global.edit}</span>
		},
		{
			value:  'delete',
			render: (
				<span className={'text-xs weight-500 error-600'}>
					{TEXTE.global.delete}
				</span>
			)
		}
	];

	useEffect(() => {
		if (step === 3)
			csvToDeviceLine();
	}, [step]);

	useEffect(() => set_modalMenu('details'), [modalEdit]);

	async function addDevice() {
		let successCount = 0;
		set_load(true);

		await Promise.all(devicesLine.map(deviceData =>
			new Promise((resolve) => {
				let contractEnd;

				if (deviceData.purchaseType === 'lease' && deviceData.purchaseDate && deviceData.duration)
					contractEnd = moment(deviceData.purchaseDate, 'DD/MM/YYYY').add(deviceData.duration, 'month').format('DD/MM/YYYY');
				else if (deviceData.purchaseType !== 'lease')
					contractEnd = deviceData.warrantlyEnd;

				const apiData: PutDeviceData = {
					name:           deviceData.name,
					state:          deviceData.state,
					serial:         deviceData.serial,
					status:         deviceData.status,
					assign:         deviceData.assign,
					network:        deviceData.network,
					funder:         deviceData.supplier,
					keyboard:       deviceData.keyboard,
					processor:      deviceData.processor,
					internalId:     deviceData.internalId,
					deviceType:     deviceData.deviceType,
					screenSize:     deviceData.screenSize,
					graphicCard:    deviceData.graphicCard,
					description:    deviceData.description,
					purchaseType:   deviceData.purchaseType,
					billingNumber:  deviceData.billingNumber,
					contractNumber: deviceData.contractNumber,
					memory:         deviceData.memory?.toString(),
					stockage:       deviceData.stockage?.toString(),
					duration:       parseInt(deviceData.duration, 10),
					locationEnd:    contractEnd ? moment(contractEnd, 'DD/MM/YYYY').toDate() : undefined,
					locationStart:  deviceData.contractStart ? moment(deviceData.contractStart, 'DD/MM/YYYY').toDate() : undefined,
					price:          parseFloat((deviceData.purchaseType === 'lease' ? deviceData.monthlyPrice : deviceData.purchasePrice)?.replace(',', '.'))
				};

				if (!apiData.locationStart && deviceData.purchaseDate)
					apiData.locationStart = moment(deviceData.purchaseDate, 'DD/MM/YYYY').toDate();

				// --- Post Device
				dispatch(postDevicesApi({data: apiData, user}))
				.then((response) => {
					if (!response.payload.status) {
						const notificationData = ft_genNotification(TEXTE, 'error', img_computer, response.payload.error);
						notificationId = ft_pushNotification(dispatch, notificationId, notificationData);
					} else
						successCount++;
					resolve(true);
				});
			})
		));

		const notificationData = ft_genNotification(TEXTE, 'addMultipleDevicesSuccess', img_computer, successCount.toString());
		notificationId = ft_pushNotification(dispatch, notificationId, notificationData);

		set_load(false);
		navigate('/devices');
	}

	function readFile(files: FileList | null) {
		if (!files?.[0])
			return (set_error('Error while reading the file'));

		API.uploadDeviceImportDocument(files?.[0], user);

		const CHUNK_SIZE = 1024;
		let fullCsv = '';
		let offset = 0;

		const readNextChunk = () => {
			const blob = files[0].slice(offset, offset + CHUNK_SIZE);
			const reader = new FileReader();

			reader.onload = (event) => {
				if (!event.target?.result) {
					set_error('Error while reading the file');
					return;
				}

				const arrayBuffer = event.target.result as ArrayBuffer;
				const byteArray = String.fromCharCode(...new Uint8Array(arrayBuffer));
				const detectedEncoding = jschardet.detect(byteArray).encoding || 'utf-8';
				const decoder = new TextDecoder(detectedEncoding);
				const text = decoder.decode(arrayBuffer);

				fullCsv += text;
				offset += CHUNK_SIZE;

				if (offset < files[0].size)
					readNextChunk(); // Lire le prochain morceau
				else {
					const result = ft_csvToArray(fullCsv);

					// Fusionner les données au fur et à mesure
					set_lineData(result);

					// Détecter les en-têtes sur le premier fragment
					const resultIndex = [];
					for (let i = 0; result[0][i]; i++)
						resultIndex.push(i);
					set_headerIndex(resultIndex);

					set_step(2); // Lecture terminée
				}
			};

			reader.onerror = () => set_error('Error while reading the file');

			reader.readAsArrayBuffer(blob);
		};

		readNextChunk();
	}

	function checkStepIsValid() : boolean {
		if (step === 2)
			return headerIndex[0] > -1 && headerIndex[1] > -1 && headerIndex[2] > -1 && headerIndex[3] > -1;

		if (step === 3)
			return !foundErrorStep3;

		return false;
	}

	function csvToDeviceLine() {
		const lines: DeviceLine[] = [];

		lineData.forEach((line, i) => {
			if (i === 0)
				return;

			const status = line[headerIndex[4]];
			let purchaseType = line[headerIndex[1]];
			let deviceType = line[headerIndex[2]];
			let state = line[headerIndex[3]];
			let finalStatus = 'stock';

			const findStatus = Object.entries(TEXTE.devices.deviceStatus).find(find => find[0] === status || find[1] === status);
			const findDeviceType = IMPORT_DATA_DEVICE_TYPE.find(find => find.text === deviceType?.toLowerCase() || find.value === deviceType?.toLowerCase());
			const findPurchaseType = IMPORT_DATA_PURCHASE_TYPE.find(find => find.text === purchaseType?.toLowerCase() || find.value === purchaseType?.toLowerCase());
			const findState = IMPORT_DATA_STATE.find(find => find.text === state?.toLowerCase() || find.value === state?.toLowerCase());

			if (findStatus)
				finalStatus = findStatus[0];

			if (findDeviceType)
				deviceType = findDeviceType.value;
			if (findPurchaseType)
				purchaseType = findPurchaseType.value;
			if (findState)
				state = findState.value;

			lines.push({
				deviceType,
				purchaseType,
				state,
				name:           line[headerIndex[0]] || line[headerIndex[17]],
				status:         finalStatus as keyof int_DeviceStatus,
				internalId:     line[headerIndex[5]],
				serial:         line[headerIndex[6]],
				supplier:       line[headerIndex[7]],
				contractStart:  line[headerIndex[8]],
				duration:       line[headerIndex[9]] ? `${parseInt(line[headerIndex[9]], 10)}` : '',
				monthlyPrice:   line[headerIndex[10]],
				contractNumber: line[headerIndex[11]],
				purchasePrice:  line[headerIndex[12]],
				purchaseDate:   line[headerIndex[13]],
				warrantlyEnd:   line[headerIndex[14]],
				billingNumber:  line[headerIndex[15]],
				description:    line[headerIndex[16]],
				brand:          line[headerIndex[17]],
				screenSize:     line[headerIndex[19]],
				keyboard:       line[headerIndex[20]],
				stockage:       line[headerIndex[21]],
				memory:         line[headerIndex[22]],
				processor:      line[headerIndex[23]],
				graphicCard:    line[headerIndex[24]],
				network:        line[headerIndex[25]],
				assign:         ft_findUser(users, line[headerIndex[26]])
			});
		});

		set_devicesLine(lines);
	}

	function checkError(line: DeviceLine) {
		const errorLine: Error[] = [];
		const importMemory = ft_fixText(line.memory);
		const importStockage = ft_fixText(line.stockage);
		const importDeviceType = ft_fixText(ft_replaceSpecialChar(line.deviceType));
		const importState = ft_fixText(ft_replaceSpecialChar(line.state)).toLowerCase();
		let importPurchaseType = ft_fixText(ft_replaceSpecialChar(line.purchaseType)).toLowerCase();

		if (!ft_fixText(line.name))
			errorLine.push({isRequiredErr: true, field: 'name'});

		if (importState && !IMPORT_DATA_STATE.find(find => find.text === importState || find.value === importState))
			errorLine.push({text: TEXTE.devices.importError.unknow, field: 'state'});

		if (importMemory && isNaN(parseFloat(importMemory)))
			errorLine.push({text: TEXTE.devices.importError.mustBeNumber, field: 'memory'});

		if (importStockage && isNaN(parseFloat(importStockage)))
			errorLine.push({text: TEXTE.devices.importError.mustBeNumber, field: 'stockage'});
		if (importStockage && (!importStockage.toLowerCase().includes('go') && !importStockage.toLowerCase().includes('to')))
			errorLine.push({text: TEXTE.devices.importError.stockageType, field: 'stockage'});


		if (!importDeviceType)
			errorLine.push({isRequiredErr: true, field: 'deviceType'});
		else if (!IMPORT_DATA_DEVICE_TYPE.find(find => find.text === importDeviceType || find.value === importDeviceType))
			errorLine.push({text: TEXTE.devices.importError.unknow, field: 'deviceType'});

		if (!importPurchaseType)
			errorLine.push({isRequiredErr: true, field: 'purchaseType'});
		else {
			const findType = IMPORT_DATA_PURCHASE_TYPE.find(find => find.text === importPurchaseType || find.value === importPurchaseType);

			if (findType)
				importPurchaseType = findType.value;
			else
				errorLine.push({text: TEXTE.devices.importError.unknow, field: 'purchaseType'});
		}

		const importPrice = ft_fixText(importPurchaseType === 'lease' ? line.monthlyPrice : line.purchasePrice)?.replace(',', '.');
		const importStartDate = ft_fixText(importPurchaseType === 'lease' ? line.contractStart : line.purchaseDate);
		const importEndDate = ft_fixText(line.warrantlyEnd);

		if (importPrice && isNaN(parseFloat(importPrice))) {
			errorLine.push({
				text:  TEXTE.devices.importError.mustBeNumber,
				field: importPurchaseType === 'lease' ? 'monthlyPrice' : 'purchasePrice'
			});
		}


		if (importStartDate && !regex_dateFormat.test(importStartDate)) {
			errorLine.push({
				text:  TEXTE.devices.importError.mustBeDate,
				field: importPurchaseType === 'lease' ? 'contractStart' : 'purchaseDate'
			});
		}
		if (importPurchaseType !== 'lease' && importEndDate && !regex_dateFormat.test(importEndDate))
			errorLine.push({text: TEXTE.devices.importError.mustBeDate, field: 'warrantlyEnd'});

		return errorLine;
	}

	function renderStep1() {
		return (
			<div>
				<Section style={{gap: 8}}>
					<span className={'text-sm weight-500 gray-700'}>{TEXTE.devices.downloadTemplate}</span>
					<a href={'/Template Valala - Ajout par lot Equipement.xlsx'} className={'no-underline'} >
						<DocumentItem
							size={60940}
							hideActionIcon
							filename={'Template Valala - Ajout par lot Equipement.xlsx'}
						/>
					</a>
				</Section>

				<Section style={{gap: 8}}>
					<span className={'text-sm weight-500 gray-700'}>{TEXTE.devices.uploadCsv}</span>
					<Input
						error={error}
						type={'file'}
						accept={'.csv'}
						onChangeFile={readFile}
						fileInputText={TEXTE.devices.onlyCSV}
					/>
				</Section>
			</div>
		);
	}

	function renderStep2() {
		const renderTable: React.ReactElement[] = [];

		TEXTE.devices.importFileHeader.forEach((_, i) => {
			const index = headerIndex[i];
			const exemple = lineData.find((find, i2) => i2 !== 0 && find[index]);

			renderTable.push(
				<tr className={''}>
					<td className={'text-xs gray-600'}>
						<span className={'weight-600'}>{TEXTE.devices.importFileHeader[i]?.name}</span><br />
						<span className={'weight-400'}>{TEXTE.devices.importFileHeader[i]?.exemple}</span>
					</td>
					<td>
						<div>
							<Select
								value={lineData[0][index]}
								data={ft_selectDataString(['', ...lineData[0]])}
								onChange={(newValue) => {
									const indexValue = lineData[0].findIndex(find => newValue !== '' && find === newValue);
									const copy = [...headerIndex];

									copy[i] = indexValue;
									set_headerIndex(copy);
								}}
							/>
						</div>
					</td>
					<td>
						<div className={'text-xs wight-400 gray-600'}>{exemple?.[index]}</div>
					</td>
					<td>
						<Icon
							iconBorder
							size={16}
							iconSize={8}
							borderSize={0}
							iconColor={'#ffffff'}
							icon={index > -1 ? img_roundCheck : img_cross}
							style={{backgroundColor: ft_cssVar(`${index > -1 ? 'success' : 'error'}-600`)}}
						/>
					</td>
				</tr>
			);
		});

		return (
			<>
				<span className={'gray-600'}>
					<span className={'weight-500 gray-700'}>{TEXTE.devices.import.howItsWork}</span>
					<li style={{marginTop: 8}}>{TEXTE.devices.import.step2Text1}</li>
					<li>{TEXTE.devices.import.step2Text2}</li>
				</span>

				<table className={'importTable'}>
					<thead>
						<tr className={'text-xs weight-500 gray-600'} style={{textAlign: 'left'}}>
							<th>{TEXTE.devices.import.propertyName}</th>
							<th>{TEXTE.devices.import.columnName}</th>
							<th>{TEXTE.devices.import.exemple}</th>
							<th style={{width: '10%'}}>{TEXTE.devices.import.status}</th>
						</tr>
					</thead>
					<tbody>
						{renderTable}
					</tbody>
				</table>
			</>
		);
	}

	function renderStep3() {
		const renderTable: React.ReactElement[] = [];

		devicesLine.forEach((deviceData, i) => {
			const foundError = checkError(deviceData);

			if (foundError.length > 0)
				foundErrorStep3 = true;

			renderTable.push(
				<tr className={''}>
					<td>
						<div>
							<Icon
								iconBorder
								iconSize={14}
								borderSize={0}
								icon={ft_getDeviceImageByString(deviceData.deviceType)}
							/>
							<span className={'text-xs weight-500 gray-900'}>{deviceData.name}</span>
						</div>
					</td>
					<td>
						<DeviceStatus forceStatus={deviceData.status} />
					</td>
					<td>
						<span className={`deviceStatus ${foundError.length > 0 ? 'needRepair' : 'active'}`}>
							{TEXTE.devices.import[foundError.length > 0 ? 'needFix' : 'success']}
						</span>
					</td>
					<td>
						<div>
							{deviceData.assign ?
								<Select
									value={deviceData.assign}
									data={ft_selectDataUser(users)}
									onClick={() => {
										set_modal(i);
										set_assignUser(users.find(find => find?._id === deviceData.assign));
									}}
								/>
								:
								<Badge
									color={'gray'}
									// img={img_usersPlus}
									text={TEXTE.global.affect}
									onClick={() => {
										set_modal(i);
										set_assignUser(null);
									}}
								/>
							}
						</div>
					</td>
					<td>{deviceData.internalId}</td>
					<td>
						<Button
							absoluteRight
							absoluteHideIcon
							type={'tertiary-gray'}
							absolute={ACTIONS_LIST}
							onChangeAbsolute={(action) => {
								if (action === 'delete') {
									const copy = [...devicesLine];
									copy.splice(i, 1);

									return set_devicesLine(copy);
								} else if (action === 'edit')
									return set_modalEdit(i);
							}}
						>
							<div className={'flex'}>
								<Icon icon={img_dotsVertical} />
								{foundError.length > 0 && <div className={'headerNotif'} />}
							</div>
						</Button>
					</td>
				</tr>
			);
		});

		return (
			<>
				<span className={'gray-600'}>
					<span className={'weight-500 gray-700'}>{TEXTE.global.about}</span>
					<li style={{marginTop: 8}}>{TEXTE.devices.import.step3Text1}</li>
					<li>{TEXTE.devices.import.step3Text2}</li>
				</span>

				<table className={'importTable'}>
					<thead>
						<tr style={{textAlign: 'left'}}>
							<th>{TEXTE.global.name}</th>
							<th>{TEXTE.global.status}</th>
							<th>{TEXTE.devices.import.import}</th>
							<th>{TEXTE.global.owner}</th>
							<th>{TEXTE.global.internalId}</th>
							<th style={{width: '10%'}}>{TEXTE.global.action}</th>
						</tr>
					</thead>
					<tbody>
						{renderTable}
					</tbody>
				</table>

				{renderModalEdit()}
			</>
		);
	}

	function renderModalEdit() {
		if (modalEdit === null || !devicesLine[modalEdit])
			return;

		const renderInput = (data: EditInput) => {
			const onChange = (newValue: InputValues | SelectValues) => {
				const copy = [...devicesLine];

				if (data.name !== 'status')
					copy[modalEdit][data.name] = newValue as string;

				set_devicesLine(copy);
			};
			const inputError = foundError.filter(e => e.field === data.name);

			if (data.selectData) {
				return (
					<Select
						title={data.title}
						onChange={onChange}
						data={data.selectData}
						value={devicesLine[modalEdit][data.name]}
						error={inputError.map(e => e.text).join('')}
						required={!!inputError.find(find => find.isRequiredErr)}
					/>
				);
			}

			return (
				<Input
					min={data.min}
					type={data.type}
					title={data.title}
					onChange={onChange}
					value={devicesLine[modalEdit][data.name]}
					error={inputError.map(e => e.text).join('')}
					required={!!inputError.find(find => find.isRequiredErr)}
					notFocusValue={(data.notFocusValue && devicesLine[modalEdit][data.name]) ? `${devicesLine[modalEdit][data.name]}${data.notFocusValue}` : undefined}
				/>
			);
		};

		const foundError = checkError(devicesLine[modalEdit]);

		return (
			<Modal
				fullWidth
				onClose={() => set_modalEdit(null)}
				cancelButton={() => set_modalEdit(null)}
				confirmButton={() => set_modalEdit(null)}
			>
				<Tabs
					actual={modalMenu}
					onChange={set_modalMenu}
					data={[
						{
							value:  'details',
							render: TEXTE.global.details,
							notif:  foundError.some(f => ['name', 'purchaseType', 'deviceType', 'contractStart', 'purchaseDate', 'duration', 'monthlyPrice', 'purchasePrice', 'contractNumber', 'warrantlyEnd', 'billingNumber'].some(val => f.field === val))
						},
						{
							value:  'characteristic',
							render: TEXTE.global.characteristic,
							notif:  foundError.some(f => ['serial', 'name', 'screenSize', 'state', 'stockage', 'memory'].some(val => f.field === val))
						}
					]}
					style={{marginBottom: 24}}
				/>

				{modalMenu === 'details' &&
					<Section style={{gap: 16}}>
						{renderInput({title: TEXTE.global.name, name: 'name'})}
						<MultiInputContainer>
							{renderInput({title: TEXTE.global.purchaseType, name: 'purchaseType', selectData: LOCATION_TYPE(TEXTE)})}
							{renderInput({title: TEXTE.global.deviceType, name: 'deviceType', selectData: DEVICE_TYPE(TEXTE)})}
						</MultiInputContainer>
						<MultiInputContainer>
							{renderInput({title: TEXTE.global.supplier, name: 'supplier'})}
							{devicesLine[modalEdit].purchaseType === 'lease' ?
								renderInput({title: TEXTE.global.contractStart, name: 'contractStart', type: 'date'})
								:
								renderInput({title: TEXTE.global.purchaseDate, name: 'purchaseDate', type: 'date'})
							}
						</MultiInputContainer>

						{devicesLine[modalEdit].purchaseType === 'lease' &&
							<MultiInputContainer>
								{renderInput({
									min:           1,
									type:          'number',
									name:          'duration',
									title:         TEXTE.global.duration,
									notFocusValue: ` ${TEXTE.global.month}`
								})}
								<Input
									readOnly
									title={TEXTE.global.contractEnd}
									value={(devicesLine[modalEdit].contractStart && devicesLine[modalEdit].duration) ?
										moment(devicesLine[modalEdit].contractStart, 'DD/MM/YYYY')
										.add(devicesLine[modalEdit].duration, 'month')
										.format('DD/MM/YYYY')
										:
										''
									}
								/>
							</MultiInputContainer>
						}

						<MultiInputContainer>
							{renderInput({
								min:           0,
								type:          'number',
								name:          devicesLine[modalEdit].purchaseType === 'lease' ? 'monthlyPrice' : 'purchasePrice',
								title:         devicesLine[modalEdit].purchaseType === 'lease' ? TEXTE.global.monthlyPrice : TEXTE.devices.purchasePrice,
								notFocusValue: '€'
							})}
							{(devicesLine[modalEdit].purchaseType === 'lease') ?
								renderInput({title: TEXTE.global.contractNumber, name: 'contractNumber'})
								:
								renderInput({title: TEXTE.global.warrantyEnd, name: 'warrantlyEnd', type: 'date'})
							}
						</MultiInputContainer>

						{devicesLine[modalEdit].purchaseType === 'purchase' &&
							renderInput({title: TEXTE.global.billingNumber, name: 'billingNumber'})
						}
					</Section>
				}

				{modalMenu === 'characteristic' &&
					<Section style={{gap: 16}}>
						<MultiInputContainer>
							{renderInput({title: TEXTE.global.serial, name: 'serial'})}
							{renderInput({title: TEXTE.global.internalId, name: 'internalId'})}
						</MultiInputContainer>
						<MultiInputContainer>
							{renderInput({title: TEXTE.global.brand, name: 'brand'})}
							{renderInput({title: TEXTE.global.name, name: 'name'})}
						</MultiInputContainer>

						<MultiInputContainer>
							{renderInput({
								min:           0,
								notFocusValue: '"',
								type:          'number',
								name:          'screenSize',
								title:         TEXTE.global.screenSize
							})}
							{renderInput({title: TEXTE.global.state, name: 'state', selectData: STATE(TEXTE)})}
						</MultiInputContainer>
						<MultiInputContainer>
							{renderInput({title: TEXTE.global.stockage, name: 'stockage', selectData: ft_selectDataGetStockage()})}
							{renderInput({title: TEXTE.global.memory, name: 'memory', selectData: ft_selectDataGetMemory()})}
						</MultiInputContainer>
						<MultiInputContainer>
							{renderInput({title: TEXTE.global.processor, name: 'processor'})}
							{(devicesLine[modalEdit].deviceType === 'computer') &&
								renderInput({title: TEXTE.global.graphicCard, name: 'graphicCard'})
							}
						</MultiInputContainer>
						<MultiInputContainer>
							{renderInput({title: TEXTE.global.network, name: 'network', selectData: ft_selectDataGetNetwork()})}
							{(devicesLine[modalEdit].deviceType === 'computer') &&
								renderInput({title: TEXTE.global.keyboard, name: 'keyboard', selectData: ft_selectDataString(KEYBOARD_LIST)})
							}
						</MultiInputContainer>
					</Section>
				}
			</Modal>
		);
	}

	function renderButtonContainer() {
		return (
			<ButtonStickyContainer>
				<Button
					fullWidth
					disabled={load}
					type={'tertiary-gray'}
					onClick={() => (step === 1 ? navigate('/devices/add') : set_step(1))}
				>
					{TEXTE.global.cancel}
				</Button>

				<Button
					fullWidth
					isLoad={load}
					disabled={!checkStepIsValid()}
					onClick={checkStepIsValid() ?
						() => (step === 3 ? addDevice() : set_step(step + 1))
						:
						undefined
					}
				>
					{step === 3 ? TEXTE.global.confirm : TEXTE.global.next}
				</Button>
			</ButtonStickyContainer>
		);
	}

	return (
		<div className={'globalDataContainer'}>
			<div className={'globalAddHeader'}>
				<Icon
					icon={img_computer}
					iconColor={'#000000'}
				/>
				<div className={'globalAddHeaderText'}>
					<span className={'text-lg weight-600 gray-900'}>{TEXTE.devices.addDeviceImportTitle}</span>
					<span className={'text-sm weight-400 gray-600'}>{TEXTE.devices.addDeviceImportData}</span>
				</div>
			</div>

			<div className={'globalAddContainer'}>
				<Tabs
					step
					actual={step}
					onChange={val => set_step(val as number)}
					data={[
						{value: 1, render: TEXTE.devices.yourFile},
						{value: 2, render: TEXTE.devices.mapping},
						{value: 3, render: TEXTE.devices.assignDevices}
					]}
				/>

				{step === 1 && renderStep1()}
				{step === 2 && renderStep2()}
				{step === 3 && renderStep3()}
			</div>

			{renderButtonContainer()}

			{modal !== null &&
				<ModalAssign
					modalRight
					load={load}
					onChange={set_assignUser}
					onClose={() => set_modal(null)}
					actualId={assignUser?._id ? [assignUser._id] : []}
					onConfirm={(newAssign) => {
						const copy = [...devicesLine];

						copy[modal].assign = newAssign;
						set_devicesLine(copy);
						set_modal(null);
					}}
				/>
			}
		</div>
	);
}

export default DevicesImport;